import React from "react";
import { Helmet } from "react-helmet-async";
import { useApp } from "@/lib/AppContext";
import { resolveImg } from "@/lib/api";

export default function SEOHead({ title, description, image, type = "website" }) {
  const { settings } = useApp();
  const siteName = settings?.site_title || "Везём авто из Европы";
  const fullTitle = title ? `${title} — ${siteName}` : siteName;
  const desc = description || "Доставка автомобилей из Европы в Россию. Подбор, проверка, таможня под ключ.";
  const ogImage = image ? resolveImg(image) : (settings?.bg_image_urls?.hero ? resolveImg(settings.bg_image_urls.hero) : "");
  const url = typeof window !== "undefined" ? window.location.href : "";

  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    "name": siteName,
    "description": desc,
    "telephone": settings?.phone,
    "email": settings?.email,
    "address": settings?.address,
    "url": url,
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      <link rel="canonical" href={url} />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
